module.exports = __webpack_public_path__ + "static/media/o4x2_temp.b9c3c414.jpg";